import { Link } from "react-router-dom";
import { brandInfo } from "@/mocks/product";
import { useWhatsAppOrder } from "@/hooks/useWhatsAppOrder";

export default function Footer() {
  const { openModal } = useWhatsAppOrder();

  return (
    <footer className="bg-accent-900 text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="/images/NeoRoop-logo-footer.png"
              alt="NeoRoop"
              className="h-12 w-auto mb-3"
            />
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              {brandInfo.tagline}
              <br />
              Quality cotton ethnic wear for everyday elegance.
            </p>
            <p className="text-white/60 text-xs">
              A unit of {brandInfo.parent}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/shop"
                  className="text-white/80 text-sm hover:text-white transition-colors"
                >
                  Shop
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-white/80 text-sm hover:text-white transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white/80 text-sm hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/policies"
                  className="text-white/80 text-sm hover:text-white transition-colors"
                >
                  Policies
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-white/80 text-sm hover:text-white transition-colors"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Connect
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 text-sm hover:text-white transition-colors inline-flex items-center gap-2"
                >
                  <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 text-sm hover:text-white transition-colors inline-flex items-center gap-2"
                >
                  <i className="ri-facebook-circle-line w-4 h-4 flex items-center justify-center" />
                  Facebook
                </a>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => openModal()}
                  className="text-white/80 text-sm hover:text-white transition-colors inline-flex items-center gap-2 cursor-pointer"
                >
                  <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
                  WhatsApp
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center" />
                {brandInfo.address}
              </li>
            </ul>
            <div className="mt-4 pt-4 border-t border-white/20">
              <p className="text-xs text-white/60">
                <i className="ri-shield-check-line w-3 h-3 flex items-center justify-center inline-flex" />
                {" "}
                Secured by Razorpay
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="w-full px-4 md:px-8 lg:px-12 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-white/60">
            © 2026 {brandInfo.name}. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            A unit of {brandInfo.parent}
          </p>
        </div>
      </div>
    </footer>
  );
}